// extracted by mini-css-extract-plugin
module.exports = {"sectionsContainer":"SectionsStepCard-sectionsContainer-10upb8"};